export default {

    async reset({ commit }) {
        commit('reset')
    },

    async setReadyForOffline({ commit }, payload = false) {
        commit('set', { readyForOffline: payload })
    },

    async send({ commit, rootState }) {
        let results = {
            status: null,
            timestamp: new Date().toUTCString()
        }

        try {
            const check = await fetch('api/v3/healthcheck').then(res => res.json())
            const conf = await fetch('api/v3/conf.json').then(res => res.json())

            if (check.version === rootState.release.version) {
                results.status = 'up_to_date'
            }
            else if (check.version === conf.release.version) {
                results.status = 'downloaded'
            }
            else { results.status = 'out_of_date' }

            commit('set', results)
        }
        catch (e) {
            console.log(e)
        }

        return results
    }
}
